import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createCompany, createFactory } from "../../api/users/companies";
import { getProjectDetail } from "../../api/project";
import CompanyForm from "../../components/company/CompanyForm";

const EMPTY_COMPANY = {
  name: "",
  registration_no: "",
  address: "",
  detail_address: "",
  extra_address: "",
  phone: "",
  email: "",
};

// 공장 행(회사 등록 시 함께 등록)
const EMPTY_FACTORY_ROW = {
  name: "",
  address: "",
  detail_address: "",
  extra_address: "",
};

const User_company = () => {
  const navigate = useNavigate();
  const projectId = localStorage.getItem("projectId");

  const [projectPeriod, setProjectPeriod] = useState({
    start_date: "",
    end_date: "",
  });

  // 회사 등록 폼
  const [newCompany, setNewCompany] = useState({ ...EMPTY_COMPANY });
  const [hasFactories, setHasFactories] = useState(false); // 공장 있음 체크
  const [factoryRows, setFactoryRows] = useState([{ ...EMPTY_FACTORY_ROW }]);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const res = await getProjectDetail(projectId);
        const data = res?.data ?? res;
        setProjectPeriod({
          start_date: data.start_date,
          end_date: data.end_date,
        });
      } catch (err) {
        console.error("프로젝트 정보 불러오기 실패:", err);
      }
    };
    if (projectId) fetchProject();
  }, [projectId]);

  const handleCreateCompany = async (payload) => {
    try {
      // payload 구조:
      // { company: {...}, factories: [...], roles: [...] }

      console.log(payload.company);
      const res = await createCompany(payload.company);

      const created = res?.data ?? res;
      const companyId = created?.id;

      // 2) 공장 등록
      if (payload.factories.length > 0 && companyId) {
        await Promise.all(
          payload.factories.map((r) =>
            createFactory({ company: companyId, ...r })
          )
        );
      }

      // 3) 멤버십 안내
      const mp = created?._membership_prompt;
      if (mp?.should_prompt && mp.user_id && mp.company_id) {
        if (
          window.confirm(
            "현재 소속된 회사가 없습니다.\n지금 등록한 회사를 내 소속 회사로 연결할까요?"
          )
        ) {
          alert("내 소속 회사로 연결되었습니다.");
        }
      }

      // 초기화
      setNewCompany({ ...EMPTY_COMPANY });
      setHasFactories(false);
      setFactoryRows([{ ...EMPTY_FACTORY_ROW }]);

      alert("회사 등록이 완료되었습니다.");
      navigate(`/project/${projectId}/system/user/company`);
    } catch (error) {
      console.error("회사 등록 실패:", error?.response?.data || error);
      alert(
        "등록 실패\n" + JSON.stringify(error?.response?.data || {}, null, 2)
      );
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">회사 등록</h2>

      {/* 회사 등록 */}
      <CompanyForm
        newCompany={newCompany}
        setNewCompany={setNewCompany}
        hasFactories={hasFactories}
        setHasFactories={setHasFactories}
        factoryRows={factoryRows}
        setFactoryRows={setFactoryRows}
        onCreate={handleCreateCompany}
        projectPeriod={projectPeriod}
        EMPTY_COMPANY={EMPTY_COMPANY}
        EMPTY_FACTORY_ROW={EMPTY_FACTORY_ROW}
      />
    </div>
  );
};

export default User_company;
